import { Component, OnInit, Inject, ViewChild, ElementRef, Renderer2} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { GlobalService } from '../../../services/global.service';
import { SnackBarService } from '../../../shared/snackbar/snackbar.service';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder, ValidatorFn } from '@angular/forms';
import Utils from '../../utility';

@Component({
  selector: 'upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.css']
})
export class UploadDocumentComponent implements OnInit {
  public categories: any;
  typeOfUpload;
  uploadDocForm: FormGroup;
  docArr;
  error;

  constructor(@Inject(MAT_DIALOG_DATA) data, private globalService: GlobalService, private snackBarService: SnackBarService, private formBuilder: FormBuilder, private dialogRef: MatDialogRef<UploadDocumentComponent>) {
    this.categories = data.categories;
    this.docArr = data.docArr;
    this.typeOfUpload = data.type;
  }

  ngOnInit() {
    this.uploadDocForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      category: [''],//, Validators.required], //by default it is already selected to the latest Category
      url: ['', Validators.required]
    });
  }

  close(): void {
    this.dialogRef.close();
  }
  
  selectedDocEvent;
  //selectedDocFilePath;
  uploadFileChanged(e) {
    this.selectedDocEvent = e;
    //this.selectedDocFilePath = e.target.files[0].name;
    this.uploadDocForm.controls['url'].setValue(e.target.files[0].name);
  }

  uploadAndSave() {
    if (this.typeOfUpload === 'marketing-material') {
      this.uploadAndSaveMM();
    } else if (this.typeOfUpload === 'info-center') {
      this.uploadAndSaveIC();
    }
  }

  uploadAndSaveMM() {
    let file;

    //if (this.selectedDocEvent && this.selectedDocEvent.target && this.selectedDocument.category && this.selectedDocument.title) {
      file = this.selectedDocEvent.target.files[0];
      //file = this.uploadDocForm.value.url;
      let formData: FormData = new FormData();
      var date = new Date().getTime() / 1000;

      //formData.append('uploadFile', localStorage.getItem('orgID') + '_' + date + '_doc' + file.substring(file.lastIndexOf('.'), file.length));
      formData.append('uploadFile', file, localStorage.getItem('orgID') + '_' + date + '_doc' + file.name.substring(file.name.lastIndexOf('.'), file.name.length));
      formData.append('Email', localStorage.getItem('email'));
      formData.append('UserID', localStorage.getItem('userId'));
      formData.append('Category', 'marketing-material');

      //this.selectedDocument.section = "marketing-material";

      let idx = 0;
      for (var key in this.categories) {
        if (this.categories[key].category === this.uploadDocForm.value.category)
          idx = Number(key);
      }

      this.globalService.UploadOrgDoc(formData)
        .subscribe(
          resp => {

            var item = {
              Category: this.uploadDocForm.value.category,
              Description: this.uploadDocForm.value.description,
              Section: this.typeOfUpload,
              Title: this.uploadDocForm.value.title,
              Url: this.globalService.assetURL + resp._body
            }

            this.docArr[idx].items.push(item);
            let arr = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.docArr);
            this.globalService.ReplaceMarketingMaterial(arr).subscribe(
              resp => {
                if (resp) {
                  this.close();
                  this.snackBarService.add('Document has been added', 0);
                } else {
                  this.snackBarService.add('An error occurred - please contact support', 1);
                }
              },
              error => this.error = <any>error);

              //this.snackBarService.add('Document has been added', 0);
          },
          error => this.error = <any>error);
    //}
  }

  uploadAndSaveIC() {
    let file;

    //if (this.selectedDocEvent && this.selectedDocEvent.target) {
      file = this.selectedDocEvent.target.files[0];
      let formData: FormData = new FormData();
      var date = new Date().getTime() / 1000;

      formData.append('uploadFile', file, localStorage.getItem('orgID') + '_' + date + '_doc' + file.name.substring(file.name.lastIndexOf('.'), file.name.length));
      formData.append('Email', localStorage.getItem('email'));
      formData.append('UserID', localStorage.getItem('userId'));
      formData.append('Category', 'info-center');

      let idx = 0;
      for (var key in this.categories) {
        if (this.categories[key].category === this.uploadDocForm.value.category)
          idx = Number(key);
      }

      this.globalService.UploadOrgDoc(formData)
        .subscribe(
          resp => {
            var item = {
              Category: this.uploadDocForm.value.category,
              Description: this.uploadDocForm.value.description,
              Section: this.typeOfUpload,
              Title: this.uploadDocForm.value.title,
              Url: this.globalService.assetURL + resp._body
            }
            
            this.docArr[idx].items.push(item);
            let arr = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.docArr);
            this.globalService.ReplaceInfoCenter(arr).subscribe(
              resp => {
                if (resp) {
                  this.close();

                  this.snackBarService.add('Document has been added', 0);
                } else {
                  this.snackBarService.add('An error occurred - please contact support', 1);
                }
              },
              error => this.error = <any>error);
            },
          error => this.error = <any>error);
    //}
  }

}
